var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoContributions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184.884,
    height: 176.011,
    viewBox: "0 0 184.884 176.011",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.m,.n,.o,.p{opacity:0.5;}.b{fill:#e0e0e0;}.c{fill:url(#a);}.d{fill:#fafafa;}.e{fill:url(#b);}.f{fill:url(#c);}.g{fill:#3b85fe;}.h{fill:url(#d);}.i{fill:#fff;}.j{fill:url(#f);}.k{fill:#ffa12d;}.l,.p{fill:#47e6b1;}.m{fill:#4d8af0;}.n{fill:#fdd835;}.o{fill:#f55f44;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.509,
    y1: 0.997,
    x2: 0.509,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.813,
    y1: 0.841,
    x2: 0.813,
    y2: -0.159,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.78,
    y1: 0.849,
    x2: 1.78,
    y2: -0.151,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 98.514,
    height: 136.114,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 15.581, 30.542)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(17.693 12.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 95.184,
    height: 131.513,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 0, 19.969)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 92.761,
    height: 128.607,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 19.08, 33.136)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 46.018,
    height: 11.147,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 40.88, 22.756)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M443.546,91.414a6.587,6.587,0,1,0,7.664,5.09A6.51,6.51,0,0,0,443.546,91.414Zm2.18,10.167a3.8,3.8,0,1,1,2.831-4.508,3.755,3.755,0,0,1-2.831,4.508Z",
    transform: "translate(-382.455 -84.131)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 45.048,
    height: 10.656,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 41.254, 22.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M443.832,91.414a6.3,6.3,0,1,0,7.477,4.835A6.3,6.3,0,0,0,443.832,91.414Zm2.083,9.716a3.634,3.634,0,1,1,2.791-4.315A3.634,3.634,0,0,1,445.914,101.129Z",
    transform: "translate(-382.74 -84.13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 98.514,
    height: 136.114,
    transform: "translate(58.134 26.354)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(59.8 28.656)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 95.184,
    height: 131.513
  })), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 92.761,
    height: 128.607,
    transform: "translate(61.01 29.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 46.018,
    height: 11.147,
    transform: "translate(84.504 24.048)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M644.754,118a6.589,6.589,0,1,0,6.433,6.587A6.511,6.511,0,0,0,644.754,118Zm0,10.387a3.8,3.8,0,1,1,3.71-3.8,3.756,3.756,0,0,1-3.71,3.783Z",
    transform: "translate(-537.241 -104.833)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 45.048,
    height: 10.656,
    transform: "translate(84.988 23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M645.226,118a6.3,6.3,0,1,0,6.3,6.3,6.3,6.3,0,0,0-6.3-6.3Zm0,9.93a3.637,3.637,0,1,0,0-.011Z",
    transform: "translate(-537.714 -104.833)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1.463 166.147)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 0.848,
    height: 4.808,
    transform: "translate(1.979)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 0.848,
    height: 4.808,
    transform: "translate(4.808 1.981) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(99.796)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 0.848,
    height: 4.808,
    transform: "translate(1.979)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 0.848,
    height: 4.808,
    transform: "translate(4.808 1.979) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M949.064,825.544a1.039,1.039,0,0,1-.579-1.256.5.5,0,0,0,.022-.115h0a.521.521,0,0,0-.935-.345h0a.5.5,0,0,0-.059.1,1.039,1.039,0,0,1-1.256.579.506.506,0,0,0-.115-.023h0a.521.521,0,0,0-.345.936h0a.5.5,0,0,0,.1.059,1.039,1.039,0,0,1,.579,1.256.5.5,0,0,0-.022.115h0a.521.521,0,0,0,.935.345h0a.494.494,0,0,0,.059-.1,1.039,1.039,0,0,1,1.256-.579.506.506,0,0,0,.115.023h0a.521.521,0,0,0,.345-.936h0A.5.5,0,0,0,949.064,825.544Z",
    transform: "translate(-775.247 -651.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M314.654,620.484a1.039,1.039,0,0,1-.579-1.255.5.5,0,0,0,.023-.115h0a.521.521,0,0,0-.935-.345h0a.506.506,0,0,0-.059.1,1.039,1.039,0,0,1-1.256.579.5.5,0,0,0-.115-.022h0a.521.521,0,0,0-.345.936h0a.5.5,0,0,0,.1.059,1.039,1.039,0,0,1,.579,1.255.5.5,0,0,0-.023.115h0a.521.521,0,0,0,.935.345h0a.5.5,0,0,0,.059-.1,1.039,1.039,0,0,1,1.256-.579.505.505,0,0,0,.115.023h0a.521.521,0,0,0,.345-.935h0a.5.5,0,0,0-.1-.059Z",
    transform: "translate(-283.846 -492.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M843.064,121.164a1.039,1.039,0,0,1-.579-1.256.5.5,0,0,0,.022-.115h0a.521.521,0,0,0-.935-.345h0a.5.5,0,0,0-.059.1,1.039,1.039,0,0,1-1.256.579.5.5,0,0,0-.115-.023h0a.521.521,0,0,0-.345.935h0a.5.5,0,0,0,.1.059,1.039,1.039,0,0,1,.579,1.256.505.505,0,0,0-.022.115h0a.521.521,0,0,0,.936.345h0a.5.5,0,0,0,.058-.1,1.039,1.039,0,0,1,1.256-.579.5.5,0,0,0,.115.023h0a.521.521,0,0,0,.345-.935h0A.5.5,0,0,0,843.064,121.164Z",
    transform: "translate(-693.141 -105.794)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.697,
    cy: 1.697,
    r: 1.697,
    transform: "translate(181.489 69.191)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.697,
    cy: 1.697,
    r: 1.697,
    transform: "translate(50.314 166.613)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.697,
    cy: 1.697,
    r: 1.697,
    transform: "translate(164.057 105.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 1.697,
    cy: 1.697,
    r: 1.697,
    transform: "translate(17.946 20.022)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 1.697,
    cy: 1.697,
    r: 1.697,
    transform: "translate(0 66.326)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoContributions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoContributions.4f471f660727c14819462e01367e5f19.svg";